import './functions';
import './logic';
import './reducers';
import './variables';
import './hooks';
import { wrapperBuilder } from './build';

export const TargetsWrapper = wrapperBuilder.build();
